<template>
  <div class="wrap-footer" :style="getStyle()">
    <div class="text-poweredby">powered by</div>
    <a :href="site" target="_blank" rel="noopener noreferrer">
      <img
        src="https://becompliance-resource.s3.us-east-2.amazonaws.com/app-resource/logo_azul_w_130.png"
        alt="Logo Be Compliance"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "BeFooter",
  props: {
    background: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      logo: process.env.VUE_APP_LOGO,
      site: process.env.VUE_APP_SITE_URL,
    };
  },

  methods: {
    betterContrastColor(hex) {
      let threshold = 130; // about 256/2 - lower values results into darker text on dark background

      const cleanHex = (h) => (h.charAt(0) == "#" ? h.substring(1, 7) : h);
      const hexToRed = (h) => parseInt(cleanHex(h).substring(0, 2), 16);
      const hexToGreen = (h) => parseInt(cleanHex(h).substring(2, 4), 16);
      const hexToBlue = (h) => parseInt(cleanHex(h).substring(4, 6), 16);

      let colorBrightness =
        (hexToRed(hex) * 299 + hexToGreen(hex) * 587 + hexToBlue(hex) * 114) /
        1000;

      return colorBrightness > threshold ? "#000000" : "#ffffff";
    },

    getStyle() {
      const color = this.betterContrastColor(this.background);
      return { color };
    },
  },
};
</script>
<style scoped>
.wrap-footer {
  display: flex;
  flex-direction: row;
  align-items: right;
  justify-content: right;
  color: #34495e;
}

.wrap-footer img {
  margin-right: 5px;
  margin-left: 5px;
  max-width: 80px;
}

.wrap-footer .text-poweredby {
  margin-top: 5px;
  font-size: 12px;
  clear: both;
}
</style>
